import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Bullet list — three dot-and-line rows. Used as the "unordered
 *  list" affordance in the writer's quick-insert palette and in any
 *  surface that signals "switch this block to an unordered list". */
export function IcnListBullet(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="list-bullet">
      <circle cx="3" cy="4.5" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="3" cy="8" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="3" cy="11.5" r="0.9" fill="currentColor" stroke="none" />
      <line x1="6" y1="4.5" x2="14" y2="4.5" />
      <line x1="6" y1="8" x2="14" y2="8" />
      <line x1="6" y1="11.5" x2="14" y2="11.5" />
    </Svg>
  );
}
